import { render } from "./IssueArticleDetails.vue?vue&type=template&id=f0f33d54"
import script from "./IssueArticleDetails.vue?vue&type=script&lang=js"
export * from "./IssueArticleDetails.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2494450445/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__